/* GGC cards: turn Affirm's long promo message into one short line ("As low as $31/mo with [Affirm]").
   The amount always comes from Affirm's own rendered message; if Affirm shows no monthly amount the slot stays empty. */
(function () {
  'use strict';
  var LOGO = 'https://cdn-assets.affirm.com/images/black_logo-transparent_bg.png';
  var queued = false;
  function fix(el) {
    if (el.classList.contains('ggc-af') || el.__ggcDone) return;
    var t = (el.textContent || '').replace(/\s+/g, ' ');
    if (!t.trim()) return;
    var m = t.match(/\$\s?(\d[\d,]*(?:\.\d\d)?)\s*\/\s*mo/i);
    el.__ggcDone = true;
    if (!m) { el.textContent = ''; return; }
    var lead = /as low as|interest-free/i.test(t) ? 'As low as' : 'From';
    el.className = 'ggc-af';
    el.removeAttribute('data-amount');
    el.innerHTML = '';
    var s = document.createElement('span'); s.className = 'ggc-af__t'; s.textContent = lead + ' $' + m[1] + '/mo with';
    var i = document.createElement('img'); i.className = 'ggc-af__logo'; i.src = LOGO; i.alt = 'Affirm'; i.width = 48; i.height = 19; i.loading = 'lazy';
    el.appendChild(s); el.appendChild(i);
  }
  function run() {
    queued = false;
    var els = document.querySelectorAll('.product-item .ggc-pricewrap > :not(.price-list):not(.ggc-af)');
    for (var k = 0; k < els.length; k++) fix(els[k]);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  var mo = new MutationObserver(function (muts) {
    for (var k = 0; k < muts.length; k++) { if (muts[k].target.closest && muts[k].target.closest('.ggc-pricewrap')) { queue(); return; } }
  });
  function start() { run(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
